import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import './V3Login.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

const V3Login = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      const response = await fetch(`${API_BASE}/v3/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email, password })
      })

      const data = await response.json()

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Autentificare eșuată')
      }

      const userData = data.data || data

      if (userData.token) {
        localStorage.setItem('authToken', userData.token)
      }

      const userInfo = {
        name: userData.name,
        email: userData.email,
        first_name: userData.first_name || userData.name?.split(' ')[0] || '',
        last_name: userData.last_name || '',
        subscription_type: userData.subscription_type,
        subscription_status: userData.subscription_status,
        subscription_expires_at: userData.subscription_expires_at,
        subscription_kind: userData.subscription_kind
      }
      
      localStorage.setItem('userData', JSON.stringify(userInfo))

      if (userData.subscription_type) {
        localStorage.setItem('subscriptionLevel', userData.subscription_type || 'free')
      }

      // Ștergem flag-ul de guest timeout la login cu succes
      localStorage.removeItem('v3_guest_timeout')

      navigate('/v3.0')
      window.location.reload()
    } catch (err) {
      setError(err.message || 'A apărut o eroare. Te rugăm să încerci din nou.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="v3-login-root">
      <div className="v3-login-container">
        <div className="v3-login-header">
          <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" className="v3-login-logo" />
          <h1>Bun venit înapoi</h1>
          <p>Conectează-te pentru a continua</p>
        </div>

        <form onSubmit={handleSubmit} className="v3-login-form">
          {error && (
            <div className="v3-login-error">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <div className="v3-login-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@exemplu.com"
              required
              disabled={loading}
            />
          </div>

          <div className="v3-login-field">
            <label htmlFor="password">Parolă</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>

          <div className="v3-login-buttons">
            <button
              type="submit"
              className="v3-login-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <svg className="v3-login-spinner" width="20" height="20" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.25"/>
                    <path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2 A10 10 0 0 1 22 12"/>
                  </svg>
                  Se conectează...
                </>
              ) : (
                'Autentificare'
              )}
            </button>

            <Link to="/subscription-premium" className="v3-login-subscribe">
              Abonează-te – 4,99 €
            </Link>
          </div>

          <div className="v3-login-links">
            <Link to="/v3.0/register" className="v3-login-link">
              Nu ai cont? Înregistrează-te
            </Link>
          </div>
        </form>

        <div className="v3-login-alephid-divider">sau</div>
        <a
          href={`${API_BASE}/auth/keycloak/redirect`}
          className="v3-login-alephid"
        >
          Intră cu Aleph ID
        </a>

        <button
          type="button"
          className="v3-login-back"
          onClick={() => navigate('/v3.0')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          Înapoi la catalog
        </button>
      </div>
    </div>
  )
}

export default V3Login

